import { ExperimentAssignment } from './abTestCookies';

declare global {
  interface Window {
    kameleoonQueue?: unknown[];
  }
}

// The queue buffers until the engine has loaded, if it ever does (consent, environment).
export function reportExposure(assignments: ExperimentAssignment[]) {
  if (!assignments.length) {
    return;
  }

  const queue = (window.kameleoonQueue = window.kameleoonQueue || []);

  assignments.forEach(([experimentId, variationId]) => {
    queue.push(['Experiments.assignVariation', experimentId, variationId]);
    queue.push(['Experiments.trigger', experimentId, true]);
  });
}
